//import {GlobalConfig} from "../Services/Helper/GlobalConfig";

// export const AppServiceName = "https://maipy6ctf4.execute-api.us-west-1.amazonaws.com/latest/v1/" //API Address
// export const AppServiceName = "http://localhost:1000/v1/"; //API Address
//export const AppServiceName = "http://infodesk.gspl.asia:3000/v1/"; //API Address
// export const AppServiceName = "http://210.212.122.183:3000/v1/"; //API Address
// export const AppServiceName = "http://18.221.127.155:3000/v1/"; //API Address
export const AppServiceName = "http://"+window.location.hostname+":3000/v1/"; //API Address
// export const AppServiceName = "http://192.168.0.102:3000/v1/"; //API Address
export const AppHostName = ""; // Self Address

export const MasterLoginEndPoint = AppServiceName + "master/login";
export const LoginEndPoint = AppServiceName + "admin/login";
export const ClientLoginEndPoint = AppServiceName + "clients/login";
export const AdminClientListEndPoint = AppServiceName + "admin/clients";
export const AdminAddClientEndPoint = AppServiceName + "admin/clients";
export const AdminDeleteClientEndPoint = AppServiceName + "admin/clients";
export const AdminDashboardEndPoint = AppServiceName + "admin/dashboard";
export const AdminDashboardMMSCMEndPoint = AppServiceName + "admin/dashboard/mmscm";
export const AdminEditClientEndPoint = AppServiceName + "admin/clients";
export const AdminClientChangePasswordEndPoint = AppServiceName + "admin/clients";
export const AdminClientDetailEndPoint = AppServiceName + "admin/clients/";
export const AdminClientViewDataEndPoint = AppServiceName + "admin/clients/";
export const AdminBaseListEndPoint = AppServiceName + "admin/bases";
export const AdminEditBaseFlowValueEndPoint = AppServiceName + "admin/bases/flowvalue";
export const AdminEditBaseDailyFlowEndPoint = AppServiceName + "admin/dashboard/daily_flow";
export const AdminUpdateClientGCEndPoint = AppServiceName + "admin/clients/";
export const AdminAddClientMeterEndPoint = AppServiceName + "admin/meters";
export const AdminEditClientMeterEndPoint = AppServiceName + "admin/meters";
export const AdminClientDeleteMeterEndPoint = AppServiceName + "admin/meters";
export const AdminMmscmCSVUploadEndPoint = AppServiceName + "admin/mmscm/upload";
export const AdminBannerUpdateEndPoint = AppServiceName + "admin/dashboard/banner";
export const AdminBannerGetEndPoint = AppServiceName + "admin/dashboard/banner";
export const AdminGetSectorEndPoint = AppServiceName + "admin/sectors";
export const AdminSectorFlowRateDataEndPoint = AppServiceName + "admin/dashboard/sector-corr-flow-rate";
export const AdminSectorFlowRateLast24DataEndPoint = AppServiceName + "admin/dashboard/sector-last-24h-volume";
export const AdminSectorWiseCustomersDataEndPoint = AppServiceName + "admin/dashboard/flowrate-volume-by-sector";

export const ClientViewDataEndPoint = AppServiceName + "clients/me";
export const AdminGCListEndPoint = AppServiceName + "admin/gcmeters";
export const AdminGCMeterEndPoint = AppServiceName + "admin/gcmeters";
export const AdminAddGCEndPoint = AppServiceName + "admin/gcmeters";
export const AdminEditGCEndPoint = AppServiceName + "admin/gcmeters";
export const AdminDeleteGCEndPoint = AppServiceName + "admin/gcmeters";
export const AdminBaseUserListEndPoint = AppServiceName + "admin";
export const AdminAddBaseUserEndPoint = AppServiceName + "admin/";
export const AdminEditBaseUserEndPoint = AppServiceName + "admin/";
export const AdminDeleteBaseUserEndPoint = AppServiceName + "admin/";
export const AdminGCViewDataEndPoint = AppServiceName + "admin/gcmeters/";
export const ClientChangePasswordEndPoint = AppServiceName + "clients/me/password";
export const BaseChangePasswordEndPoint = AppServiceName + "admin/me/password";
